import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=0cf504e9&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf504e9')) {
      api.createRecord('0cf504e9', component.options)
    } else {
      api.reload('0cf504e9', component.options)
    }
    module.hot.accept("./form-item.vue?vue&type=template&id=0cf504e9&", function () {
      api.rerender('0cf504e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/form/src/form-item.vue"
export default component.exports